// Perguntas operacionais do dia a dia do Autopilot (PO1-2095). Constante ÚNICA
// compartilhada entre a home (views/Autopilot/index.js) e o chat
// (views/Autopilot/AutopilotChat.js) — antes eram dois arrays duplicados que
// precisavam ser mantidos idênticos na mão.
//
// Grid 2 colunas (7 tiles hoje): 4 operacionais (canais, silêncio, faturas a
// vencer, vencidas) + 2 mantidos (Resumo 24h, Custos do mês) + Cotar frete
// (PO1-2705/H5). Shape { icon, color, label, prompt } — icon é classe
// tim-icons, color é token --everlog-status-*. Grid é auto-flow (2 colunas),
// então adicionar itens só cria mais uma linha, sem quebrar o layout.
export const QUICK_PROMPTS = [
  {
    icon: "icon-refresh-01",
    color: "var(--everlog-status-info)",
    label: "Canais funcionando?",
    prompt: "Como estão os canais de integração agora (calc-frete e NFe)? Tem algo degradado?",
  },
  {
    icon: "icon-bus-front-12",
    color: "var(--everlog-status-warning)",
    label: "Transportadora em silêncio",
    prompt: "Tem alguma transportadora vinculada que não está enviando arquivo nos últimos 3 dias?",
  },
  {
    icon: "icon-calendar-60",
    color: "var(--everlog-status-accent)",
    label: "Faturas a vencer",
    prompt: "Quais faturas estão vencendo nos próximos 7 dias?",
  },
  {
    icon: "icon-alert-circle-exc",
    color: "var(--everlog-status-danger)",
    label: "Faturas vencidas",
    prompt: "Tem faturas vencidas em aberto? Quais?",
  },
  {
    // Mantido (cor ajustada p/ status-success — evita 2 tiles info no grid).
    icon: "icon-time-alarm",
    color: "var(--everlog-status-success)",
    label: "Resumo das últimas 24h",
    prompt: "Faça um resumo da operação das últimas 24 horas e destaque os pontos que exigem ação imediata.",
  },
  {
    // Mantido verbatim (fecha o trio: saúde + operação + dinheiro).
    icon: "icon-money-coins",
    color: "#00d6b4",
    label: "Custos de frete do mês",
    prompt:
      "Faça um resumo dos meus custos de frete do mês atual: custo total, custo médio por CT-e e comparação com o mês anterior. Aponte os estados de destino que mais pesam no custo e destaque variações relevantes.",
  },
  {
    // PO1-2705/H5: cotação de frete conversacional (épico PO1-2700).
    icon: "icon-delivery-fast",
    color: "var(--everlog-status-info)",
    label: "Cotar frete",
    prompt: "Quero cotar um frete",
  },
];
